import React from "react";

import dayjs from "dayjs";
import { isNull } from "lodash/lang";
import advancedFormat from "dayjs/plugin/advancedFormat";

import CoverPage from "./CoverPage";
import DisciplineBreakdown from "./DisciplineBreakdown";
import DisciplineTips1 from "./DisciplineTips1";
import DisciplineTips2 from "./DisciplineTips2";
import DisciplineTips3 from "./DisciplineTips3";
import DisciplineTips4 from "./DisciplineTips4";
import Footer from './Footer';
import Intro from "./Intro";
import OhsPdfPage from "./OhsPdfPage";
import ResultsSummary from "./ResultsSummary";
import Images from "../Images";
import SurveyService from "../../services/SurveyService";
import {AppPdfWrapper} from "../index";

dayjs.extend(advancedFormat);

const getScoreDetails = (score, lowThreshold, highThreshold) => {
  if (score < lowThreshold) {
    return {
      icon: "low",
      score: score,
    };
  }

  if (score >= highThreshold) {
    return {
      icon: "high",
      score: score,
    };
  }

  return {
    icon: "medium",
    score: score,
  };
};

const PoweredBy = () => (
  <div className={"ohs-cover__footer-bar"}>
    <div className={"ohs-cover__powered"}>Powered by:</div>
    <img
      className={"ohs-cover__footer-logo"}
      src={Images.logoWhite}
      alt="tablegroup-logo"
    />
  </div>
);

const SurveyPdf = () => {
  const [details, setDetails] = React.useState(null);
  const [filters, setFilters] = React.useState(null);
  const [disciplineOne, setDisciplineOne] = React.useState({});
  const [disciplineTwo, setDisciplineTwo] = React.useState({});
  const [disciplineThree, setDisciplineThree] = React.useState({});
  const [disciplineFour, setDisciplineFour] = React.useState({});

  const highThreshold = 4,
    lowThreshold = 3;
  const date = dayjs().format("MMMM Do, YYYY");

  const _getDetails = React.useCallback(() => {
    const params = Object.fromEntries(new URLSearchParams(window.location.search));

    Object.keys(params)
      .filter((k) => k.startsWith("question"))
      .forEach((k) => {
        params[k] = Number(params[k]);
      });

    setFilters(params);

    SurveyService.getSurveyPdfDetails(params, "survey").then((response) => {
      const details = response.data;
      setDetails(details);

      setDisciplineOne(
        getScoreDetails(
          details.disciplines[0].average,
          lowThreshold,
          highThreshold,
        ),
      );
      setDisciplineTwo(
        getScoreDetails(
          details.disciplines[1].average,
          lowThreshold,
          highThreshold,
        ),
      );
      setDisciplineThree(
        getScoreDetails(
          details.disciplines[2].average,
          lowThreshold,
          highThreshold,
        ),
      );
      setDisciplineFour(
        getScoreDetails(
          details.disciplines[3].average,
          lowThreshold,
          highThreshold,
        ),
      );
    });
  }, []);

  React.useEffect(() => {
    _getDetails();
  }, [_getDetails]);

  return (
    !isNull(details) && (
      <AppPdfWrapper className={"AssessmentReport ohs"}>
        <OhsPdfPage Footer={<PoweredBy />}>
          <CoverPage
            firstName={filters.first_name}
            lastName={filters.last_name}
            date={date}
          />
        </OhsPdfPage>

        <OhsPdfPage Footer={<Footer page={2} />}>
          <Intro />
        </OhsPdfPage>

        <OhsPdfPage Footer={<Footer page={3} />}>
          <DisciplineBreakdown />
        </OhsPdfPage>

        <OhsPdfPage Footer={<Footer page={4} />}>
          <ResultsSummary
            disciplineOne={disciplineOne}
            disciplineTwo={disciplineTwo}
            disciplineThree={disciplineThree}
            disciplineFour={disciplineFour}
          />
        </OhsPdfPage>

        <OhsPdfPage Footer={<Footer page={5} />}  showBackground>
          <DisciplineTips1 score={disciplineOne.icon} />
        </OhsPdfPage>

        <OhsPdfPage Footer={<Footer page={6} />}  showBackground>
          <DisciplineTips2 score={disciplineTwo.icon} />
        </OhsPdfPage>

        <OhsPdfPage Footer={<Footer page={7} />}  showBackground>
          <DisciplineTips3 score={disciplineThree.icon} />
        </OhsPdfPage>

        <OhsPdfPage Footer={<Footer page={8} />} showBackground>
          <DisciplineTips4 score={disciplineFour.icon}/>
        </OhsPdfPage>
      </AppPdfWrapper>
    )
  );
};

export default SurveyPdf;
